export default {
  props: {
    height: {
      type: String,
      default: '16'
    },
    width: {
      type: String,
      default: '16'
    },
    color: {
      type: String,
      default: '#667488'
    }
  }
}
